import styled from "styled-components";
import {MainNavCanvasDefaultBox} from "./main-nav-canvas.default.box";
import {hexToRgba} from "../../../../themes/hex-to-rgba";

export const MainNavCanvasCasino777Box = styled(MainNavCanvasDefaultBox)`
  background: linear-gradient(#8ad0b8 25%, #cce6c9 70%, #fcf6d5);
  box-shadow: 1rem 0 3rem ${props => hexToRgba(props.theme.colors.brandPrimaryContrast, 0.2)};
`